document.addEventListener('DOMContentLoaded', () => {
  const affinityPortal = document.querySelector('#recharge-customer-portal');

  if (!affinityPortal) return;

  const observer = new MutationObserver(() => {
    const provinceSelector = document.querySelector('.recharge-modal-wrapper select[name="province"]');

    if (!provinceSelector) return;

    const options = provinceSelector.querySelectorAll('option');
    const exclusionStates = [
      'Alaska',
      'Hawaii',
      'American Samoa',
      'Armed Forces Americas',
      'Armed Forces Europe',
      'Armed Forces Pacific',
      'District of Columbia',
      'Federated States of Micronesia',
      'Guam',
      'Marshall Islands',
      'Northern Mariana Islands',
      'Palau',
      'Puerto Rico',
      'Virgin Islands',
    ];

    options.forEach((option) => {
      if (!exclusionStates.includes(option.value)) return;
      option.remove();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
